import { useEffect, useState } from 'react'
import { filesManagerServiceFetch } from '../../../../../utils/constants/callService'
import { formatListAlreadyUsersPermissions } from '../../../../../service/filesManager/format'
import { useParams } from 'react-router-dom'


const useGetData = () => {
  const { id: fileId } = useParams()

  const [dataEndpoint, setDataEndpoint] = useState<{
    seeFile: boolean,
    downloadFile: boolean,
    userId: number,
    firstName: string,
    lastName: string,
    fullName: string,
    area: string,
    department: string,
    areaId: number[],
    departmentId: number[],
    role: string,
    roleId: number,
    userTypeDescription: string,
    userType: number | null
  }[]
  >([])

  const getData = () => {
    getAccesData()
  }

  const getAccesData = async () => {
    const response = await filesManagerServiceFetch.getUsersWithPermmisions({ id: Number(fileId) })

    const { row } = formatListAlreadyUsersPermissions({ response })

    setDataEndpoint(row)
  }

  useEffect(() => {
    getData()
  }, [])
  return { dataEndpoint }
}

export { useGetData }
